module.exports = __webpack_public_path__ + "static/media/product-12.96a4c947.jpg";